/** Figma duration stat — ``Est. 5 mins`` from API minutes-only field. */
export function formatEstimatedDuration(minutes: number): string {
  const safe = Math.max(1, Math.round(minutes))
  if (safe === 1) {
    return 'Est. 1 min'
  }
  return `Est. ${safe} mins`
}
